var map = {
	"./pages/background/background.module.ngfactory": [
		"./src/app/pages/setup/pages/background/background.module.ngfactory.js",
		34
	],
	"./pages/blur/blur.module.ngfactory": [
		"./src/app/pages/setup/pages/blur/blur.module.ngfactory.js",
		12
	],
	"./pages/check/check.module.ngfactory": [
		"./src/app/pages/check/check.module.ngfactory.js",
		25
	],
	"./pages/confirm/confirm.module.ngfactory": [
		"./src/app/pages/confirm/confirm.module.ngfactory.js",
		"common",
		15
	],
	"./pages/course/course.module.ngfactory": [
		"./src/app/pages/members/pages/course/course.module.ngfactory.js",
		1,
		3,
		"common",
		13
	],
	"./pages/courses/courses.module.ngfactory": [
		"./src/app/pages/members/pages/courses/courses.module.ngfactory.js",
		1,
		"common",
		18
	],
	"./pages/forgotpass/forgotpass.module.ngfactory": [
		"./src/app/pages/forgotpass/forgotpass.module.ngfactory.js",
		26
	],
	"./pages/goals/goals.module.ngfactory": [
		"./src/app/pages/members/pages/goals/goals.module.ngfactory.js",
		"common",
		19
	],
	"./pages/intro/intro.module.ngfactory": [
		"./src/app/pages/setup/pages/intro/intro.module.ngfactory.js",
		3,
		"common",
		23
	],
	"./pages/invite/invite.module.ngfactory": [
		"./src/app/pages/setup/pages/invite/invite.module.ngfactory.js",
		35
	],
	"./pages/language/language.module.ngfactory": [
		"./src/app/pages/language/language.module.ngfactory.js",
		27
	],
	"./pages/login/login.module.ngfactory": [
		"./src/app/pages/login/login.module.ngfactory.js",
		"common",
		16
	],
	"./pages/members/members.module.ngfactory": [
		"./src/app/pages/members/members.module.ngfactory.js",
		17
	],
	"./pages/nudge/nudge.module.ngfactory": [
		"./src/app/pages/members/pages/nudge/nudge.module.ngfactory.js",
		"common",
		14
	],
	"./pages/nudges/nudges.module.ngfactory": [
		"./src/app/pages/members/pages/nudges/nudges.module.ngfactory.js",
		"common",
		20
	],
	"./pages/pledge/pledge.module.ngfactory": [
		"./src/app/pages/members/pages/pledge/pledge.module.ngfactory.js",
		"common",
		21
	],
	"./pages/profile/pages/badge/badge.module.ngfactory": [
		"./src/app/pages/members/pages/profile/pages/badge/badge.module.ngfactory.js",
		4,
		"common",
		28
	],
	"./pages/profile/pages/badges/badges.module.ngfactory": [
		"./src/app/pages/members/pages/profile/pages/badges/badges.module.ngfactory.js",
		4,
		"common",
		29
	],
	"./pages/profile/pages/details/details.module.ngfactory": [
		"./src/app/pages/members/pages/profile/pages/details/details.module.ngfactory.js",
		30
	],
	"./pages/profile/pages/personal/personal.module.ngfactory": [
		"./src/app/pages/members/pages/profile/pages/personal/personal.module.ngfactory.js",
		1,
		"common",
		31
	],
	"./pages/profile/pages/shared/shared.module.ngfactory": [
		"./src/app/pages/members/pages/profile/pages/shared/shared.module.ngfactory.js",
		1,
		"common",
		32
	],
	"./pages/register/register.module.ngfactory": [
		"./src/app/pages/register/register.module.ngfactory.js",
		"common",
		22
	],
	"./pages/resetpass/resetpass.module.ngfactory": [
		"./src/app/pages/resetpass/resetpass.module.ngfactory.js",
		33
	],
	"./pages/setup/setup.module.ngfactory": [
		"./src/app/pages/setup/setup.module.ngfactory.js",
		24
	],
	"./pages/theme/theme.module.ngfactory": [
		"./src/app/pages/setup/pages/theme/theme.module.ngfactory.js",
		36
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;